import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@sg/garnish';

import { useFloatingBottomBarSpacing } from '@order/shared-hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationFloatingBar = (props: PropsWithChildren) => {
  const { floatingBottomBarStyle } = useFloatingBottomBarSpacing();

  return (
    <View style={[styles.floatingWrapper, floatingBottomBarStyle]} pointerEvents="box-none">
      {props.children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  floatingWrapper: {
    position: 'absolute',
    right: 0,
    left: 0,
    gap: theme.spacing['4'],
    marginHorizontal: theme.spacing['4'],
  },
});
